import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { motion, AnimatePresence } from 'framer-motion';
const rotatingWords = ['marketing', 'product', 'revops', 'research', 'growth', 'sales', 'design'];
export function AboutPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % rotatingWords.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-148">
      <Navigation data-id="element-149" />

      <main className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 pt-28 sm:pt-36 pb-24 sm:pb-32" data-id="element-150">
        {/* Hero Heading - Large, centered */}
        <h1 className="text-4xl sm:text-5xl md:text-[3.5rem] font-medium text-[#0F0F0F] tracking-tight leading-[1.15] text-center mb-12 max-w-3xl mx-auto" style={{
        fontSize: '40px',
        fontWeight: '700',
        paddingTop: '10px',
        paddingBottom: '10px'
      }} data-id="element-151">
          AI search analytics for{' '}
          <span className="inline-flex items-center justify-center overflow-hidden border border-dashed border-[#D0CEC9] rounded-lg px-2 py-0" style={{
          width: '200px',
          height: '1.18em',
          verticalAlign: 'baseline'
        }} data-id="element-152">
            <AnimatePresence mode="wait" data-id="element-153">
              <motion.span key={rotatingWords[currentIndex]} initial={{
              y: '100%',
              opacity: 0
            }} animate={{
              y: '0%',
              opacity: 1
            }} exit={{
              y: '-100%',
              opacity: 0
            }} transition={{
              duration: 0.45,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="inline-block text-[#0F0F0F]" data-id="element-154">
                {rotatingWords[currentIndex]}
              </motion.span>
            </AnimatePresence>
          </span>
        </h1>

        {/* Two-column intro section */}
        <section className="mb-16" data-id="element-155">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 md:gap-16" data-id="element-156">
            <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight" style={{
            fontWeight: '600'
          }} data-id="element-157">
              Andoe sits between LLM responses and execution.
            </h2>
            <div className="space-y-4 text-[15px] text-[#3D3D3D] leading-relaxed" data-id="element-158">
              <p data-id="element-159">As AI has improved, execution has become easier.</p>
              <p data-id="element-160">
                Content can be generated faster, and tools now automate work
                that once required entire teams.
              </p>
              <p data-id="element-161">What hasn't become easier is knowing what actually matters.</p>
              <p data-id="element-162">
                Some describe this shift as a game of taste or authenticity. We
                see it more plainly: strategy now carries more weight. Once
                direction is clear, execution follows.
              </p>
              <p data-id="element-163">
                We believe AI visibility is the beginning of how businesses are
                understood.
              </p>
              <p data-id="element-164">
                AI systems are forming probabilistic responses about companies
                long before people visit a website, talk to sales, or read
                documentation. Those responses shape discovery, comparison, and
                trust.
              </p>
              <p data-id="element-165">
                We are building Andoe as the platform where teams understand and
                manage their AI-driven profile over time.
              </p>
            </div>
          </div>
        </section>

        {/* Co-build invitation */}
        <section className="border-t border-[#E8E6E3] pt-16" data-id="element-166">
          <div data-id="element-167">
            <h2 className="text-2xl sm:text-[1.75rem] font-medium text-[#0F0F0F] leading-snug tracking-tight mb-6" style={{
            fontWeight: '600'
          }} data-id="element-168">
              Build Andoe with us
            </h2>
            <div className="space-y-4 text-[15px] text-[#3D3D3D] leading-relaxed" data-id="element-169">
              <p data-id="element-170">
                We're an early-stage team, and the best products are built with
                real feedback from real users. We're looking for teams who want
                to shape Andoe alongside us — not just use it, but help define
                what it becomes.
              </p>
              <p data-id="element-171">
                If you're dealing with AI visibility challenges and want a tool
                built around your actual workflow, we'd love to hear from you.
              </p>
            </div>
            <Link to="/contact" className="inline-flex items-center mt-8 px-6 py-3 text-base font-medium rounded-lg bg-[#1A1A1A] text-white hover:bg-[#0F0F0F] transition-colors duration-200" data-id="element-172">
              Get in touch
            </Link>
          </div>
        </section>
      </main>

      <Footer data-id="element-173" />
    </div>;
}